import THdev from './config/th/dev.json';
import THstg from './config/th/stg.json';
import THprd from './config/th/prd.json';
import CKdev from './config/ck/dev.json';
import CKstg from './config/ck/stg.json';
import CKprd from './config/ck/prd.json';

export type Tenant = 'ck' | 'th';
export type Environment = 'dev' | 'stg' | 'prd';
type FirebaseConfigurationObject = {
  apiKey: string;
  authDomain: string;
  databaseURL?: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
};
type EnvironmentConfiguration = Partial<
  Record<Environment, FirebaseConfigurationObject>
>;
type FirebaseConfiguration = Partial<Record<Tenant, EnvironmentConfiguration>>;
export const firebaseConfiguration: FirebaseConfiguration = {
  th: {
    dev: THdev,
    stg: THstg,
    prd: THprd,
  },
  ck: {
    dev: CKdev,
    stg: CKstg,
    prd: CKprd,
  },
};
